export default "__VITE_ASSET__cde5dd4a__"